import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import SelectProduct from 'Components/Organisms/SelectProduct/SelectProduct';

export default function RHFSelectProduct({ name, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <SelectProduct {...field} error={error?.message} {...other} />
            )}
        />
    );
}

RHFSelectProduct.propTypes = {
    name: PropTypes.string.isRequired,
};
